module.exports = __webpack_public_path__ + "img/inno-support.61607469.png";